import type { Flow } from '../flow';
import { uiCopy } from '../copy';
import { errorCopy } from '../errors';
import { useFlowState } from './useFlow';
import { IconChevron } from './icons';
import ctaArt from './cta-art.webp';
import ctaScenesArt from './cta-scenes-art.webp';

/** De knop op de PDP: onder de preview (mobiel) of boven "Bewerken" (desktop). */
export function Cta({ flow }: { flow: Flow }) {
  const { applied } = useFlowState(flow);
  const t = uiCopy(flow.shopId);
  const unavailable = flow.availabilityError ? errorCopy(flow.availabilityError, undefined, flow.shopId) : null;
  const scenes = flow.variant === 'scenes';
  const name = flow.catalog?.catalog?.name;
  const art = flow.ctaImageUrl || (scenes ? ctaScenesArt : ctaArt);
  const title = applied
    ? t.ctaApplied
    : name ?? (scenes ? t.ctaScenes : t.ctaStyles);
  return (
    <button type="button" class={applied ? 'cta cta--applied' : 'cta'} onClick={() => flow.open()} aria-haspopup="dialog">
      <span class="badge badge--ribbon">{applied ? t.badgeDone : t.badgeNew}</span>
      <span class="cta__art">
        <img src={art} alt="" width="72" height="72" />
      </span>
      <span class="cta__text">
        <span class="cta__title">{title}</span>
        <span class="cta__sub">{unavailable ? unavailable.title : applied ? t.ctaSubApplied : t.ctaSub}</span>
      </span>
      <span class="cta__chev">
        <IconChevron />
      </span>
    </button>
  );
}
